import { gql } from '@apollo/client';

export const UPDATE_FORM_BANNER = gql`
  mutation UpdateFormBanner(
    $id: Int!
    $updateFormBannerInput: UpdateBannerFormInput!
  ) {
    UpdateFormBanner(id: $id, updateFormBannerInput: $updateFormBannerInput) {
      id
      content
      userId
      bannerId
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_MANY_FORM_BANNERS = gql`
  mutation DeleteManyFormBanners($ids: [Int!]!) {
    DeleteManyFormBanners(ids: $ids) {
      count
    }
  }
`;

export const FIND_ONE_FORM_BANNER = gql`
  query FindOneFormBanner($id: Int!) {
    FindOneFormBanner(id: $id) {
      id
      content
      userId
      bannerId
      createdAt
      updatedAt
    }
  }
`;

export const FIND_MANY_FORM_BANNER = gql`
  query FindManyFormBanners($ids: [Int!]!) {
    FindManyFormBanners(ids: $ids) {
      id
      content
      userId
      bannerId
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_FORM_BANNER = gql`
  mutation CreateFormBanner($createFormInput: CreateBannerFormInput!) {
    CreateFormBanner(createFormInput: $createFormInput) {
      id
      content
      userId
      bannerId
      updatedAt
      updatedAt
    }
  }
`;

export const AUTOCOMPLETE_FORM_BANNERS = gql`
  query autocompleteFormBanners(
    $bannerId: Int!
    $userId: Int!
    $autocompleteFilter: AutocompleteFilter!
  ) {
    autocompleteFormBanners(
      bannerId: $bannerId
      userId: $userId
      autocompleteFilter: $autocompleteFilter
    )
  }
`;

export const FILTER_FORM_BANNERS = gql`
  query filterFormBanners(
    $bannerId: Int!
    $userId: Int!
    $searchFilter: SearchFilter!
  ) {
    filterFormBanners(
      bannerId: $bannerId
      userId: $userId
      searchFilter: $searchFilter
    ) {
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        id
        products {
          code
          ean
          dynamic
          primary
          price
          promotional
        }
        signature
        user {
          id
          name
          username
        }
        bannerId
        createdAt
        updatedAt
      }
    }
  }
`;
